export default __webpack_public_path__ + "locales/bg/DeleteThirdPartyDialog.json?hash=2c43c08af2ffbb6cfc85409928562dd2";